// extracted by mini-css-extract-plugin
var _1 = "_transferInventoryForm-module__button-container";
var _2 = "_transferInventoryForm-module__button-subcontainer";
var _3 = "_transferInventoryForm-module__container";
var _4 = "_transferInventoryForm-module__form-container";
var _5 = "_transferInventoryForm-module__serial-container";
var _6 = "_transferInventoryForm-module__serial-list";
var _7 = "_transferInventoryForm-module__serial-number";
var _8 = "_transferInventoryForm-module__span-2";
var _9 = "_transferInventoryForm-module__title";
export { _1 as "button-container", _2 as "button-subcontainer", _3 as "container", _4 as "form-container", _5 as "serial-container", _6 as "serial-list", _7 as "serial-number", _8 as "span-2", _9 as "title" }
